import { useEffect, useState } from "react";
import { useAuth } from "@clerk/react";

const REFRESH_INTERVAL_MS = 30 * 1000;

/**
 * The current Clerk session token for the copilot runtime. CopilotKit's `headers` are a plain object, so the token
 * is kept in state and re-read every 30 s, well inside its 60 s lifetime (Clerk serves it from cache and refreshes it
 * in the background). Null until the first read, or when there is no session.
 */
export function useCopilotAccessToken(): string | null {
  const { getToken } = useAuth();
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const read = () => getToken().then(setToken, () => setToken(null));
    read();
    const id = setInterval(read, REFRESH_INTERVAL_MS);
    return () => clearInterval(id);
  }, [getToken]);

  return token;
}
